<template>
  <ion-page>
    <master-layout pageTitle="لیست محصولات انبار">
      <ion-card>
        <ion-card-content>
          <DataTable v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      product_id:null,
      type:'',
      route : null,
      headers:[
        'محصول',
        'ویژگی',
        'تاریخ',
        'نوع',
        'موجودی قبلی',
        'موجودی جدید',
        'علت تراکنش',
        // 'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
    this.productId = this.$route.params.productId;
    console.log(this.id)
    console.log(this.productId)
    let route = 'WarehouseTransaction/ListAjax/'+this.is;
    if (this.productId)
      route += '/'+this.productId;

    this.route = route;
    this.type = this.$route.query.type
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>